import React from 'react';
import { useCmsText } from '../../hooks/useCmsText';

interface ResultBoxProps {
  type: string;
  message: string;
  caseId?: string;
}

const ResultBox = ({ type, message, caseId }: ResultBoxProps) => {
  const { renderPlainText: renderText } = useCmsText();

  const getHeading = (type: string) => {
    switch (type) {
      case 'risk': return renderText('result_risk_heading', 'Stopp - Fremstår utrygt!');
      case 'warn': return renderText('result_warn_heading', 'Vær forsiktig');
      case 'safe': return renderText('result_safe_heading', 'Fremstår som trygg');
      default: return renderText('result_warn_heading', 'Vær forsiktig');
    }
  };

  const getBgClasses = (type: string) => {
    switch (type) {
      case 'risk': return 'risk-dark-bg risk-light-bg';
      case 'warn': return 'warn-dark-bg warn-light-bg';
      case 'safe': return 'safe-dark-bg safe-light-bg';
      default: return 'warn-dark-bg warn-light-bg';
    }
  };

  const getIcon = (type: string) => {
    switch (type) {
      case 'risk': return '/images/risk.png';
      case 'warn': return '/images/warn.png';
      case 'safe': return '/images/safe.png';
      default: return '/images/warn.png';
    }
  };

  const getTextColorClass = (type: string) => {
    switch (type) {
      case 'risk': return 'text-dark-red';
      case 'safe': return 'text-dark-green';
      case 'warn': return 'text-dark-yellow';
      default: return 'text-dark-yellow';
    }
  };

  const bgClasses = getBgClasses(type);

  return (
    <div className='w-full flex flex-col mt-10 px-4'>
      {/* Result Card Header */}
      <div className={`w-full p-6 md:p-8 h-auto ${bgClasses.split(' ')[0]} rounded-t-lg flex flex-col items-center justify-center`}>
        <img
          width={'40'}
          height={'40'}
          src={getIcon(type)}
          alt="icon"
          className="mb-4"
        />
        <p className={`text-xl font-bold text-black text-center`}>{getHeading(type)}</p>

        {/* Case ID Badge */}
        {caseId && (
          <div className="mt-4 px-4 py-2 rounded-lg bg-black/10 flex items-center gap-2">
            <span className={`text-xs font-semibold uppercase opacity-70 ${getTextColorClass(type)}`}>
              {renderText('result_case_id_label', 'Case ID')}
            </span>
            <span className={`text-sm font-semibold ${getTextColorClass(type)}`}>
              {caseId}
            </span>
          </div>
        )}
      </div>

      {/* Analysis Details Card */}
      <div className={`w-full p-4 md:p-6 lg:p-8 ${bgClasses.split(' ')[1]} rounded-b-lg flex flex-col justify-center`}>
        {/* <p className="text-sm font-semibold text-slate-800 uppercase tracking-wide mb-3">
          {renderText('result_details_title', 'Analysis Details')}
        </p> */}
        {/* <div className="h-px bg-slate-200 mb-4"></div> */}
        <p className={`text-md ${getTextColorClass(type)} whitespace-pre-line leading-relaxed`}>
          {message || 'No detailed information available.'}
        </p>
      </div>
    </div>
  );
};

export default ResultBox;
